module.exports = __webpack_public_path__ + "img/user-photo.99b71d46.png";